<template>
  <div class="help-open">
    <div class="open-block">
      <div class="block-txt1">帮亲友开通会员</div>
      <div class="block-txt2">{{ title }} x1</div>
      <input type="text" v-model="mobile" placeholder="请输入好友手机号" class="div-input">
    </div>
    <div class="submit-btn" @click="handleSubmit" :class="isOver ? 'cur' : ''">验证身份后开通</div>
    <div class="con-tips">
      <div class="txt1">购买须知</div>
      <div class="txt2">您将购买的为促销推广产品，购买后不支持退订、退换，请斟酌确认。</div>
      <div class="txt2">购买后可在“定制订单”查看。</div>
    </div>
  </div>
</template>
<script>
import { giveToFriends } from '@/api/person'
import store from '@/store'
export default {
  data () {
    return {
      mobile: ''
    }
  },
  computed: {
    isOver () {
      return this.mobile.length > 0
    },
    title () {
      return this.$route.query.title
    }
  },
  mounted () {
  },
  methods: {
    handleSubmit () {
      if (!this.mobile) {
        this.$toast('请填写号码')
      }
      let params = {
        mobile: this.mobile
      }
      giveToFriends(params).then(res => {
        if (res.code === 1) {
          store.dispatch('GetUsers').then(res => {
            setTimeout(() => {
              this.$router.push({
                path: `/paySuccess2?mobile=${this.mobile}`
              })
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.help-open {
  background-color: #1E2020;
  padding: 20px 0;
  box-sizing: border-box;
  width: 100vw;
  min-height: 100vh;

  .open-block {
    border-radius: 10px;
    padding: 0 14px;
    padding-top: 18px;
    box-sizing: border-box;
    background-color: #2F3131;

    .block-txt1 {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 500;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .block-txt2 {
      color: #999999;
      font-size: 12px;
      line-height: 12px;
    }

    .div-input {
      margin-top: 20px;
      border: none;
      border-top: 1px solid #4F5252;
      height: 66px;
      line-height: 66px;
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      outline: none;
      width: 100%;
      background-color: transparent;

      &::placeholder {
        color: #999999;
        font-weight: 400;
      }
    }
  }

  .submit-btn {
    margin-top: 20px;
    width: 347px;
    height: 48px;
    border-radius: 100px;
    background-color: #6C685E;
    margin-left: 14px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    color: #504632;
    font-weight: 600;

    &.cur {
      background-color: #F0E1C0;
      color: #504632;
    }
  }

  .con-tips {
    margin-top: 20px;
    padding: 0 14px;
    box-sizing: border-box;

    .txt1 {
      font-size: 14px;
      line-height: 14px;
      color: #FFFFFF;
    }

    .txt2 {
      font-size: 12px;
      line-height: 16px;
      color: #999999;
      margin-top: 12px;
      position: relative;
      padding-left: 12px;

      &::before {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 100px;
        background-color: #999999;
        content: "";
        top: 4px;
        left: 0;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/personal/helpOpen.vue